import { createContext } from 'react';

export const ContextLoader = createContext();